module.exports = __webpack_public_path__ + "img/whatsnew-selectioncolorfill_cn.6deb20f.jpg";